import { BookOpenCheck, Layers } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import type { CatalogMatchResult } from "@/lib/api/catalog";

interface JournalMatchPanelProps {
  match: CatalogMatchResult;
  onReceiveIssue: () => void;
  onCancel: () => void;
}

export function JournalMatchPanel({ match, onReceiveIssue, onCancel }: JournalMatchPanelProps) {
  if (!match.biblio || !match.biblioId) return null;
  return (
    <Card className="overflow-hidden bg-white shadow-sm">
      <div className="space-y-6 p-6">
        <div className="flex items-start gap-3">
          <BookOpenCheck className="mt-1 h-6 w-6 text-primary" />
          <div>
            <p className="text-sm font-medium text-primary">Existing ISSN match</p>
            <h2 className="text-xl font-semibold text-gray-900">{match.biblio.title}</h2>
            <p className="mt-1 text-sm text-gray-600">ISSN {match.biblio.issn ?? "—"}</p>
          </div>
        </div>
        <div className="grid gap-3 sm:grid-cols-3">
          <div className="rounded-lg bg-gray-50 p-3">
            <p className="text-xs text-gray-500">Volumes</p>
            <p className="font-semibold text-gray-900">{match.volumeCount ?? 0}</p>
          </div>
          <div className="rounded-lg bg-gray-50 p-3">
            <p className="text-xs text-gray-500">Issues</p>
            <p className="font-semibold text-gray-900">{match.issueCount ?? 0}</p>
          </div>
          <div className="rounded-lg bg-gray-50 p-3">
            <p className="text-xs text-gray-500">Copies</p>
            <p className="font-semibold text-gray-900">{match.existingCopyCount}</p>
          </div>
        </div>
        <div className="flex flex-wrap justify-end gap-2">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={onReceiveIssue}>
            <Layers className="mr-2 h-4 w-4" />
            Receive Issue
          </Button>
        </div>
      </div>
    </Card>
  );
}
